import {Component} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCheck, faSquarePlus, faSquareXmark} from '@fortawesome/free-solid-svg-icons';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-add-hot-listed-vehicle',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
    templateUrl: './add-hot-listed-vehicle.component.html',
    styleUrl: './add-hot-listed-vehicle.component.css'
})
export class AddHotListedVehicleComponent {
  hotListForm: FormGroup;

  
  constructor(private apiService: ApiService,
    private router: Router,
    private toastr:ToastrService,
    fb: FormBuilder,
    library: FaIconLibrary) {
    library.addIcons(faCheck,
                    faSquareXmark,
                    faSquarePlus  
                  )
    

    this.hotListForm = fb.group({
      vehicleNumber: ['', Validators.required],
        personName: [''],
      reason: ['', [Validators.required, Validators.maxLength(300)]]
    });
  }


  onSubmit() {
    if (this.hotListForm.valid) {
      let formdata = new FormData();
      formdata.append('vehicle_number', this.hotListForm.value.vehicleNumber);
        if (this.hotListForm.value.personName) {
            formdata.append('person_name', this.hotListForm.value.personName);
        }
      formdata.append('reason', this.hotListForm.value.reason);
      formdata.append('is_active', 'true');
      this.apiService.addHotList(formdata).subscribe({
          next: (response:any) => {
            this.toastr.success(`${this.hotListForm.value.vehicleNumber} is added in HotList.`, 'Success');
            this.router.navigate(['/view-hotlist']);
          },
          error: (err) => {
            if (err['error']['non_field_errors']) {
              err['error']['non_field_errors'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            }else if (err['error']['vehicle_number']) {
              err['error']['vehicle_number'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['status'] !== 403 && err.status !== 0) {
              this.toastr.error("Something went wrong!", 'Error');
            }
          }
        }
      )
    } else {
      this.validateAllFormFields(this.hotListForm);
    }
  }
  validateAllFormFields(formGroup: FormGroup) {   
    Object.keys(formGroup.controls).forEach(field => {  
      const control = formGroup.get(field);             
      if (control instanceof FormGroup) {        
        this.validateAllFormFields(control);            
      } else {                                      
        control?.markAsTouched({ onlySelf: true });
      }
    });
  }

  onCancel() {
    this.router.navigate(['/view-hotlist']);

  }

}
